var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.3077H6.86908C3.64807 24.3077 1.05633 21.6602 1.12485 18.4399L1.19663 15.066C1.26873 11.6773 2.43527 8.40286 4.52196 5.73189L7.43749 2.00001C8.30233 0.893013 9.89823 0.690943 11.0117 1.54745C12.1159 2.39686 12.337 3.97389 11.509 5.09422L8.94112 8.56835C8.45595 9.22476 8.93829 10.1538 9.75454 10.1538C12.3784 10.1538 14.5385 12.2809 14.5385 14.9047V18.7692C14.5385 21.828 12.0588 24.3077 9 24.3077Z",
    stroke: "#6D9FE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4614 24.3077H25.3305C22.1095 24.3077 19.5178 21.6602 19.5863 18.4399L19.6581 15.066C19.7302 11.6773 20.8967 8.40286 22.9834 5.73189L25.8989 2.00001C26.7638 0.893013 28.3597 0.690943 29.4731 1.54745C30.5773 2.39686 30.7984 3.97389 29.9704 5.09422L27.4025 8.56835C26.9174 9.22476 27.3997 10.1538 28.216 10.1538C30.8398 10.1538 32.9999 12.2809 32.9999 14.9047V18.7692C32.9999 21.828 30.5202 24.3077 27.4614 24.3077Z",
    stroke: "#6D9FE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.c922340e62097ebad33bf012bb4f0672.svg";
export { ForwardRef as ReactComponent };